import { LitElement, html, css } from 'lit';
import '../../Time/Timestamp';
import { Text } from '../../Text/Text.js';
import '../../ReadMark/SingleMark/SingleMark.js';
import '../../ReadMark/BlueReadMark/BlueReadMark.js';
import '../../ReadMark/DoubleMark/DoubleMark.js';
import '../../ReadMark/ClockMark/ClockMark.js';
import { processTextWithMentions } from '../../../../lib/taguser.js';
import'../../ForwardMessage/ForwardUi.js'

class OutgoingTextMessageBubble extends LitElement {
  // Add to properties
  static properties = {
    bgColor: { type: String },
    borderWidth: { type: String },
    borderColor: { type: String },
    borderStyle: { type: String },
    borderRadius: { type: String },
    padding: { type: String },
    height: { type: String },
    width: { type: String },
    time: { type: String },
    textContent: { type: String },
    alignSelf: { type: String },
    isRead: { type: Boolean },
    isPopupOpen: { type: Boolean },
    fontFamily: { type: String },
    isDelivered: { type: String },
    textColor: { type: String },
    mentionedUsers: { type: Array },
    showEmojiReactions: { type: Boolean },
    messageType: { type: Number },
    timeColor: { type: String },

    customType: { type: String },
  };

  constructor() {
    super();
    this.isPopupOpen = false;
    this.mentionedUsers = [];
    this.showEmojiReactions = false;
  }

  static styles = css`
    .message-container {
      position: relative;
      min-width: fit-content;
      width: fit-content;
      max-width: 80%;
      align-self: center;
      overflow-wrap: break-word;
      margin-right: 10px;
    }

    .message-footer {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: end;
      gap: 2px;
    }

    .actions {
      position: absolute;
      left: -15px;
      cursor: pointer;
      top: 5px;
    }

    .popup {
      position: absolute;
      top: 0px;
      left: -100px;
      background-color: white;
      border: 1px solid #eef1fa;
      border-radius: 5px;
      padding: 10px;
      box-shadow: 0 2px 10px #eef1fa;
      z-index: 10;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .popup div {
      cursor: pointer;
    }

    .mention {
      font-weight: bold;
      cursor: pointer;
    }
  `;

  handleMentionClick = user => {
    this.dispatchEvent(
      new CustomEvent('tagUserClick', {
        detail: { userId: user?.userId, userName: user?.userName },
        bubbles: true,
        composed: true,
      }),
    );
  };

  static getCustomTypeStylesAndSuffix(customType, bgColor, textColor) {
    if (customType === 'PAYMENT_ESCROWED') {
      return {
        suffix: 'Payment Escrowed',
        showSuffix: true,
        bgColor: '#FFFFFF',
        textColor: '#241172',
        fontSize: '12px',
        fontWeight: '400',
      };
    } else if (customType === 'DEAL_COMPLETE') {
      return {
        suffix: 'Deal Completed',
        showSuffix: true,
        bgColor: '#E1EEEC',
        textColor: '#1CA48F',
        fontSize: '12px',
        fontWeight: '400',
      };
    } else if (customType === 'CANCEL_DEAL' || customType === 'CANCEL_OFFER') {
      return {
        suffix: 'Deal Cancelled',
        showSuffix: true,
        bgColor: '#FFFFFF',
        textColor: '#F52F2F',
        fontSize: '12px',
        fontWeight: '400',
      }; 
    } else if (customType === 'OFFER_SENT') {
      return {
        suffix: 'Offer Sent',
        showSuffix: true,
        bgColor: '#FFFFFF',
        textColor: '#241172',
        fontSize: '12px',
        fontWeight: '400',
      }; 
    } else if (customType === 'REVIEW_RATING') {
      return {
        suffix: '',
        showSuffix: true,
        bgColor: '#FFFFFF',
        textColor: '#241172',
        fontSize: '12px',
        fontWeight: '400',
      }; 
    }else if (customType === 'EDIT_OFFER') {
      return {
        suffix: ' Edit Offer',
        showSuffix: true,
        bgColor: '#FFFFFF',
        textColor: '#241172',
        fontSize: '12px',
        fontWeight: '400',
      }; 
    } else if (customType === 'COUNTER_OFFER') {
      return {
        suffix: ' Counter Offer',
        showSuffix: true,
        bgColor: '#FFFFFF',
        textColor: '#241172',
        fontSize: '12px',
        fontWeight: '400',
      }; 
    } else if (customType === 'ACCEPT_OFFER') {
      return {
        suffix: ' Accept Offer',
        showSuffix: true,
        bgColor: '#E1EEEC',
        textColor: '#1CA48F',
        fontSize: '12px',
        fontWeight: '400',
      }; 
    } else if (customType === 'EXCHANGE_OFFER_SENT') {
      return {
        suffix: ' Trade Offer Sent',
        showSuffix: true,
        bgColor: '#FFFFFF',
        textColor: '#241172',
        fontSize: '12px',
        fontWeight: '400',
      }; 
    } else if (customType === 'ACCEPT_EXCHANGE_OFFER') {
      return {
        suffix: ' Offer Accepted',
        showSuffix: true,
        bgColor: '#E1EEEC',
        textColor: '#1CA48F',
        fontSize: '12px',
        fontWeight: '400',
      }; 
    } 
    return {
      suffix: '',
      showSuffix: false,
      bgColor: bgColor,
      textColor: textColor,
      fontSize: 'inherit',
      fontWeight: 'inherit',
    };
  }

  render() {
    const {
      suffix,
      showSuffix,
      bgColor: customBgColor,
      textColor: customTextColor,
      fontSize: customFontSize,
      fontWeight: customFontWeight,
    } = OutgoingTextMessageBubble.getCustomTypeStylesAndSuffix(
      this.customType,
      this.bgColor,
      this.textColor
    );
    return html`
      <div
        class="message-container"
        @emoji-selected="${this.handleEmojiSelect}"
        style="padding:${this.padding || '10px'}; 
          border-width: ${this.borderWidth};
          border-color: ${this.borderColor};
          border-style:${this.borderStyle };
          border-radius:${this.borderRadius || '10px'};
          height:${this.height};
          background-color:${this.bgColor};
          align-self: ${this.alignSelf || 'right'};
          font-family: ${this.fontFamily};
          color: ${this.textColor};
         "
      >
      ${showSuffix
        ? html`<div class="message-suffix-container" style="background-color:${customBgColor}; color:${customTextColor}; font-size:${customFontSize}; font-weight:${customFontWeight}; margin-bottom:4px; padding:2px 8px; border-radius:6px; display:inline-block; width:max-content;">${suffix}</div>`
        : null}
        ${this.messageType === 1
          ? html`
            <forward-ui></forward-ui>
            `
          : null}
        ${Text({
          content:
            processTextWithMentions(this.textContent, this.mentionedUsers, this.handleMentionClick, true) ||
            'some outgoing message sssj sj sj ssj ssj  some some smosk ajabfa bfa bfhjab ome somesomesomesome',
          textAlign: 'left',
          fontFamily: this.fontFamily,
          color: this.textColor,
        })}
        <div class="message-footer">
          <div>
            <timestamp-element .time="${this.time || new Date().toISOString()}" .color="${this.timeColor}"></timestamp-element>
          </div>

          ${this.isRead
            ? html`<blue-read-mark></blue-read-mark>`
            : this.isDelivered === 'true'
              ? html`<double-mark svgFillColor="${this.textColor}"></double-mark>`
              : this.isDelivered === 'pending'
                ? html`<clock-mark svgFillColor="${this.textColor}"></clock-mark>`
                : html`<single-mark></single-mark>`}
        </div>
      </div>
    `;
  }
}

customElements.define('outgoing-text-message-bubble', OutgoingTextMessageBubble);
